// extracted by mini-css-extract-plugin
export var active = "_5y-b";
export var activeIndicator = "_5y-6";
export var animate = "_5y-a";
export var disabled = "_5y-c";
export var flat = "_5y-1";
export var fullWidth = "_5y-3";
export var lg = "_5y-9";
export var md = "_5y-8";
export var redoButtonTabGroup = "_5y-0";
export var sm = "_5y-7";
export var tabButton = "_5y-4";
export var tabButtonsContainer = "_5y-2";
export var xs = "_5y-5";